/**
 * The AI guide's size limit and checks, apart from the built-in text so the
 * admin's bundle doesn't carry the whole built-in guide.
 */

/** Longest guide body that can be saved; AI tools read the whole guide, so it has to stay readable. */
export const MAX_GUIDE_CHARS = 60000;

/** Problems with a guide body someone wants to save; empty when it's fine. */
export const validateGuideBody = (body: string): string[] => {
  const text = String(body || '');
  const problems: string[] = [];
  if (!text.trim()) problems.push('The guide can’t be empty.');
  if (text.length > MAX_GUIDE_CHARS) problems.push(`The guide is ${text.length.toLocaleString('en-US')} characters; keep it under ${MAX_GUIDE_CHARS.toLocaleString('en-US')}.`);
  return problems;
};
